import logo from "@/assets/boomerang_logo.png";

/**
 * Loader animé à la marque Boomerang : logo qui "respire" avec halo orange,
 * anneaux "signal de tracking" et piste animée (rappel de la route pointillée du logo).
 * Variantes : inline (défaut), fullscreen (gate de route), overlay (au-dessus d'un contenu).
 */
export const BrandLoader = ({
  fullscreen = false,
  overlay = false,
  label = "Chargement…",
  size = 64,
  rings = true,
  className = "",
}) => {
  const core = (
    <div
      className={`flex flex-col items-center justify-center gap-4 ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid="brand-loader"
    >
      <div className="bl-wrap" style={{ height: size, width: size * 2.4 }}>
        {rings && (
          <>
            <span className="bl-ring" />
            <span className="bl-ring" style={{ animationDelay: "0.6s" }} />
            <span className="bl-ring" style={{ animationDelay: "1.2s" }} />
          </>
        )}
        <img src={logo} alt="Boomerang" className="bl-logo" style={{ height: size, width: "auto", position: "relative", zIndex: 1 }} />
      </div>
      <div className="bl-track" style={{ width: size * 2 }} />
      {label && <span className="bl-label text-xs font-semibold tracking-wide text-muted-foreground">{label}</span>}
    </div>
  );

  if (fullscreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="brand-loader-fullscreen">
        {core}
      </div>
    );
  }
  if (overlay) {
    return (
      <div className="absolute inset-0 z-50 flex items-center justify-center bg-background/70 backdrop-blur-sm" data-testid="brand-loader-overlay">
        {core}
      </div>
    );
  }
  return core;
};

export default BrandLoader;
